import { useAppOrgStatusQuery } from '../types/generated';

interface OrganizationStatus {
    loading: boolean;
    hasValidTaxForm: boolean;
    hasValidPayoutSettings: boolean;
    payoutSettingsPreview: string;
    hasRejectedPayout: boolean;
    hasUnclaimedPayout: boolean;
    periodFrom: Date | null;
    periodTo: Date | null;
    amount: number;
    displayAmount: string;
    refetch: () => void;
}

export const useOrganizationStatus = (): OrganizationStatus => {
    const { data, loading, refetch } = useAppOrgStatusQuery();

    return {
        loading,
        hasValidTaxForm: data?.appOrgStatus.hasValidTaxForm || false,
        hasValidPayoutSettings: data?.appOrgStatus.hasValidPayoutSettings || false,
        payoutSettingsPreview: data?.appOrgStatus.payoutSettingsPreview || '',
        hasRejectedPayout: data?.appOrgStatus.hasRejectedPayout || false,
        hasUnclaimedPayout: data?.appOrgStatus.hasUnclaimedPayout || false,
        periodFrom:
            (data?.appOrgStatus.periodFrom && new Date(data?.appOrgStatus.periodFrom)) || null,
        periodTo: (data?.appOrgStatus.periodTo && new Date(data?.appOrgStatus.periodTo)) || null,
        amount: data?.appOrgStatus.amount || 0,
        displayAmount: data?.appOrgStatus.displayAmount || '',
        refetch,
    };
};
